import { render } from "./HospitalSearchKeywordManage.vue?vue&type=template&id=b723c932&scoped=true"
import script from "./HospitalSearchKeywordManage.vue?vue&type=script&lang=js"
export * from "./HospitalSearchKeywordManage.vue?vue&type=script&lang=js"

import "./HospitalSearchKeywordManage.vue?vue&type=style&index=0&id=b723c932&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b723c932"]])

export default __exports__